import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import { Contact, contactWithDefault } from '../types/user';
import {
  Message,
  MyInfoWrapper,
  MessageInput,
  editedInputColor,
} from './common/styled';
import { User } from '../types/user';
interface Props {
  userInfoList: {
    tagKey: keyof User;
    tagName: string;
    privateIsDisabled: boolean;
    isPublic: boolean;
    inputValue: string;
  }[];
  emailInvalid: boolean;
  currentInvalid: boolean;
  homeInvalid: boolean;
}

export const MyPageContact = memoNamed<Props>('MyPageContact', (props) => {
  const [contact, setContact] = useState<Contact>('none');
  const [contactLoading, setContactLoading] = useState<boolean>(false);
  const [contactEdited, setContactEdited] = useState<boolean>(false);

  useEffect(() => {
    const user = firebase.auth().currentUser;
    const db = firebase.firestore();
    db.collection('Users')
      .where('userID', '==', user?.uid)
      .get()
      .then((snapshot) => {
        setContact(snapshot.docs[0].data().contact);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const selectStyle = contactEdited
    ? {
        color: editedInputColor,
        borderColor: editedInputColor,
        backgroundColor: '#eaeaea',
        width: '98%',
      }
    : {
        backgroundColor: '#eaeaea',
        width: '98%',
      };

  const onContactChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const _contact = contactWithDefault(event.target.value);
      setContact(_contact);
      setContactEdited(false);
      const user = firebase.auth().currentUser;
      const db = firebase.firestore();
      setContactLoading(true);
      db.collection('Users')
        .where('userID', '==', user?.uid)
        .get()
        .then((snapshot) => {
          const id = snapshot.docs[0].id;
          db.collection('Users')
            .doc(id)
            .update({
              contact: _contact,
            })
            .then(() => {
              setContactLoading(false);
              setContactEdited(true);
            })
            .catch((error) => {
              console.error(error);
              setContactLoading(false);
            });
        })
        .catch((error) => {
          setContactLoading(false);
          console.error(error);
        });
    },
    []
  );
  const email = useMemo(
    () =>
      props.userInfoList.find((u) => u.tagKey === 'email')?.inputValue ?? '',
    [props]
  );

  const postNumber = useMemo(
    () =>
      props.userInfoList.find((u) => u.tagKey === 'postNumber')?.inputValue ??
      '',
    [props]
  );

  const address = useMemo(
    () =>
      props.userInfoList.find((u) => u.tagKey === 'address')?.inputValue ?? '',
    [props]
  );

  const postNumberHome = useMemo(
    () =>
      props.userInfoList.find((u) => u.tagKey === 'postNumberHome')
        ?.inputValue ?? '',
    [props]
  );

  const addressHome = useMemo(
    () =>
      props.userInfoList.find((u) => u.tagKey === 'addressHome')?.inputValue ??
      '',
    [props]
  );
  return (
    <div>
      <MyInfoWrapper>
        桃源会からの連絡先{contactLoading ? ' 通信中...' : undefined}
        {contactEdited ? <MessageInput>【保存済】</MessageInput> : undefined}
        <Message>
          {contact === 'email' && props.emailInvalid
            ? `以前${email}にEmailを送信しましたが、不着でした。別の連絡手段に変更するか、連絡用Emailアドレスを更新してください。`
            : contact === 'current' && props.currentInvalid
            ? `以前${
                postNumber === '' ? '' : '〒'
              }${postNumber} ${address}宛に郵送致しましたが不着でした。他の連絡手段を選択するか、現住所を最新の情報に更新してください。`
            : contact === 'home' && props.homeInvalid
            ? `以前${
                postNumberHome === '' ? '' : '〒'
              }${postNumberHome} ${addressHome}宛に郵送致しましたが不着でした。他の連絡手段を選択するか、現住所を最新の情報に更新してください。`
            : undefined}
          {contact === 'email' && !props.emailInvalid && email === ''
            ? 'Emailが未記入です。下の連絡先の欄にEmailを入力するか、他の空で無い連絡先を選択してください。'
            : undefined}
          {contact === 'current' && !props.currentInvalid && address === ''
            ? '現住所が未記入です。下の連絡先の欄に現住所を入力するか、他の空で無い連絡先を選択してください。'
            : undefined}
          {contact === 'home' && !props.homeInvalid && addressHome === ''
            ? '帰省先住所が未記入です。下の連絡先の欄に帰省先住所を入力するか、他の空で無い連絡先を選択してください。'
            : undefined}
        </Message>
        <select style={selectStyle} value={contact} onChange={onContactChange}>
          <option value='email'>
            Email(推奨):
            {email}
          </option>
          <option value='current'>
            現住所(郵送):
            {`${postNumber === '' ? '' : '〒'}${postNumber} ${address}`}
          </option>
          <option value='home'>
            帰省先(郵送):
            {`${
              postNumberHome === '' ? '' : '〒'
            }${postNumberHome} ${addressHome}`}
          </option>
          <option value='none'>送らない</option>
        </select>
      </MyInfoWrapper>
    </div>
  );
});
